import React, { useState, useEffect, useRef } from 'react';
import './AiSearchPage.css';
import axios from 'axios';
import settings from '../../config/settings';
import { TheHeader } from '../../containers';
import { CButton, CCol, CInput, CRow, CContainer } from '@coreui/react';
import { Accordion, AccordionSummary, AccordionDetails, Chip, Menu, MenuItem, IconButton, Box, Tooltip  } from '@mui/material';
import { Stack, Typography } from '@mui/material';
import { useHistory } from "react-router";
import { CircularProgress } from '@mui/material';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import { isEmpty } from 'lodash';
import { ToastContainer, toast } from 'react-toastify';
// import { cilTrash } from '@coreui/icons';
import uuid from 'react-uuid';
import Badge from '@mui/material/Badge';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import SendRoundedIcon from '@material-ui/icons/SendRounded';

import { ChatMessage } from '../../constants/model';
import ChatDeleteConfirmation from './chatDeleteConfirmation';
import AiSearchPdfDrawer from './AiSearchPdfDrawer';
import ChatDeleteAllConfirmation from './chatDeleteAllConfirmation';
import { handleApiError } from '../../session/session-expire';

const toast_options = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
   };
const title_text = {
    color: 'white',
    position: "fixed",
    top: "100px",
    left: "50px",
    zIndex: "1030",
    fontWeight: "bold",
    cursor: 'pointer',
    "@media (max-width: 1200px)": {
        top: '135px'
    }
}
const loader = {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    background: "rgba(255,255,255,0.4)",
    zIndex: "9999",
    display: "table",
    width: "100%",
    height: "100%"
}

const btn_style = {
    fontSize: '30px',
    cursor: 'pointer',
    float: "right"
}

const AiSearchPage = () => {
    const history = useHistory()
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [savedQuestions, setSavedQuestions] = useState([]);
    const [showStartMessage, setShowStartMessage] = useState(true);
    const [Isloader, setIsloader] = React.useState(false);
    const [showChatHistory, setShowChatHistory] = useState(false);
    const [conversationId, setConversationId] = useState(null);
    const [suggestionlist, setSuggestionlist] = useState([]);
    const [isSuggessionLoading, setIsSuggessionLoading] = useState(false);
    const [isHistoryLoading, setIsHistoryLoading] = useState(false);
    const [hoveredItemId, setHoveredItemId] = useState(null);
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);
    const [isDeleteAllConfirmationOpen, setIsDeleteAllConfirmationOpen] = useState(false);
    const [selectedChatConvId, setSelectedChatConvId] = useState(null);
    const [selectedMatch, setSelectedMatch] = useState(null);
    const [showSuggesion, setShowSuggesion] = useState(false);
    const [isFileDownloadLoading, setIsFileDownloadLoading] = useState(false);
    const [editingItemId, setEditingItemId] = useState(null);
    const [editValue, setEditValue] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorE2, setAnchorE2] = useState(null);
    const [dropdownItemId, setDropdownItemId] = useState(null);
    const [isEditHisotryLoading, setIsEditHisotryLoading] = useState(false);
    const [ASSISTANT, TOOL, ERROR] = ['assistant', 'tool', 'error']
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isLikeDislikeLoading, setIsLikeDislikeLoading] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [isDeleteAllMenuOpen, setIsDeleteAllMenuOpen] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState('')
    const [selectedCollection, setSelectCollection] = useState('none')
    const NO_CONTENT_ERROR = 'No content in messages object.'
    const messagesEndRef = useRef(null);
    const abortController = new AbortController();
    const user_id = localStorage.getItem("userId")
 
    let assistantMessage = {}
    let toolMessage = {}
    let assistantContent = ''
    let userMessage = {};

    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    };
    
    // let conversationId = ''

    useEffect(() => {
        handleSaveHistory(true);
        fetchSuggestionsList()
    }, []);

        // Scroll to the bottom of the messages
        const scrollToBottom = () => {
            if (messagesEndRef.current) {
                messagesEndRef?.current?.scrollIntoView();
            }
        };
    
        useEffect(() => {
            scrollToBottom();
        }, [messages]);

    const processResultMessage = (resultMessage, conversationId) => {
        console.log("resultMessage :: ", conversationId, resultMessage);
        if (typeof resultMessage.content === "string" && resultMessage.content.includes('all_exec_results')) {
            const parsedExecResults = JSON.parse(resultMessage.content)
            //   setExecResults(parsedExecResults.all_exec_results)
            console.log("parsedExecResults",parsedExecResults)
            assistantMessage.context = JSON.stringify({
                all_exec_results: parsedExecResults.all_exec_results
            })
        }
       
        if (resultMessage.role === ASSISTANT) {
            //   setAnswerId(resultMessage.id)
            let rawData = resultMessage.content.trim();
            let content = {}
            try{
                content = JSON.parse(rawData)
                console.log(" resultMessage.content", content)
            }
            catch(e){
                console.log("catch in parse ",e)
                rawData = rawData.replace(/^```json/, "").replace(/```$/, "").trim();
                let lastCommaIndex = rawData.lastIndexOf(',');
                if (lastCommaIndex !== -1) {
                    rawData = rawData.substring(0, lastCommaIndex) + '}]}';
                }
                content = JSON.parse(rawData)
                console.log(" resultMessage.content", content)
            }

            // assistantContent +=  content
            assistantMessage = { ...assistantMessage, ...resultMessage }
            assistantMessage.id = uuid()
            assistantMessage.content = content

            console.log("assistantContent===", assistantContent, resultMessage)
            if (resultMessage.context) {
                toolMessage = {
                    id: uuid(),
                    role: TOOL,
                    content: resultMessage.context,
                    date: new Date().toISOString()
                }
            }
        }

        if (resultMessage.role === "tool") toolMessage = resultMessage
        console.log("resultMessage :: ::", resultMessage);
        console.log("userMessage-userMessage", userMessage)
        console.log("messagesmessagesmessagesmessages", messages)
        console.log("messages", assistantMessage)
        console.log("conversationId", conversationId, !conversationId)
        let final_msg=[];

        if (!conversationId) {
            if(isEmpty(toolMessage)){
                final_msg = [...messages, userMessage, assistantMessage]
            }else{
                final_msg = [...messages, userMessage, toolMessage, assistantMessage]
            }
        } else {
            if(isEmpty(toolMessage)){
                final_msg = [...messages, userMessage, assistantMessage]
            }else{
                final_msg = [...messages, userMessage, toolMessage, assistantMessage]
            }
        }
        setMessages(final_msg)
        console.log("final_msg final_msg",final_msg);
        // if (!conversationId) {
        //     isEmpty(toolMessage)
        //         ? setMessages([...messages, userMessage, assistantMessage])
        //         : setMessages([...messages, userMessage, toolMessage, assistantMessage])

        // } else {
        //     isEmpty(toolMessage)
        //         ? setMessages([...messages, assistantMessage])
        //         : setMessages([...messages, toolMessage, assistantMessage])
        // }        
        setIsloader(false)
        return final_msg;
    }
    const submitEditHandler = async (e) => {
        e.preventDefault();
        if (!input.trim()){
          toast.warn('Please enter at least one search term.', toast_options);
           return;
        } 
        
        if(selectedCollection === 'none'){
            toast.warn(`Select a valid data source (excluding 'None') relevant to the search query.`, toast_options);
            return;
        }
        setShowStartMessage(false);
        setIsloader(true)      

        const headers = {
            'Accept': 'application/x-ndjson',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        };
        // const id = "ce2003a1-6e6c-99ef-b825-03280c43617f";
        // const role = "user";
        // const content = input || "default content";

        // const date = new Date().toISOString();

        userMessage = {
            ...userMessage,
            role: "user",
            content: input || "default content",
            sourcedata:selectedCollection,
            // id : "ce2003a1-6e6c-99ef-b825-03280c43617f",
            id : uuid(),
            // user_id : user_id,
            date : new Date().toISOString()
        }

        setMessages([...messages, userMessage])

        // userMessage.role = role;
        // userMessage.content = content;
        // userMessage.id = id;
        // userMessage.date = date;
        try {
            
            let body_message =  
                {
                messages : [ userMessage ],
                }

                if(conversationId?.length > 4){
                    body_message.conversation_id =  conversationId
                }
            
                body_message.user_id = user_id;
                body_message.sourcedata = selectedCollection;

            const body = JSON.stringify(body_message);

            console.log("body----",body)
            const response = await fetch(`${settings.serverUrl}/history/generate`, {
                method: 'POST',
                headers: headers,
                body: body
            })
            console.log(":::---response---:::",response)
            // Check if the response is ok (status code 200)
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            let final_text = ''
            const reader = response.body.getReader()
            let result = {}
            let runningText = ''
            let conversationResponse;
            while (true) {
                const { done, value } = await reader.read()
                if (done) break

                var text = new TextDecoder('utf-8').decode(value)
                const objects = text.split('\n');
                objects.forEach(obj => {
                    try {
                        if (obj !== '' && obj !== '{}') {
                            runningText += obj
                            result = JSON.parse(runningText)
                            console.log("result :: ", result);
                            if (result.choices?.length > 0) {
                                if (result?.history_metadata && result?.history_metadata?.conversation_id) {
                                    // let convId = result.history_metadata?.conversation_id
                                    setConversationId(result?.history_metadata?.conversation_id)
                                    // conversationId = result.history_metadata?.conversation_id
                                    // setSelectedConversationId(result.history_metadata?.conversation_id)
                                }
                                let res_msg =  result.choices[0].messages
                                if(res_msg?.length > 0){
                                    conversationResponse = processResultMessage(res_msg[0], conversationId)
                                }
                            } else if (result.error) {
                                throw Error(result.error)
                            }
                            runningText = ''
                        }
                    } catch (e) {
                        handleApiError(e, history);
                        if (!(e instanceof SyntaxError)) {
                            console.error(e)
                            throw e
                        } else {
                            console.log('Incomplete message. Continuing...',e)
                        }
                    }
                })
            }
            console.log("final Text", final_text)
            console.log("conversationResponse", conversationResponse)
            // const reply = JSON.parse(response.data?.result).choices[0].message.content;
            // console.log("response-chat-gpt-api",response.data?.result.choices[0].message.content)
            // const reply = response.data?.result.choices[0].message.content;
            // const newMessages = [...messages, { query: input, reply }];
            // setIsloader(false)
            // setMessages(newMessages);

            // const newSavedQuestions = [...savedQuestions, input];
            // setSavedQuestions(newSavedQuestions);
            historyUpdate(conversationResponse,result?.history_metadata?.conversation_id)
 
            setInput('');
        } catch (error) {
            handleApiError(error, history);
            console.error('Error:', error);
        } finally{
            setIsloader(false)
        }
    };

    // const transformData = (data) => {
    //     return data?.map((group) => {
    //       const title = group[0]?.title || 'Untitled';
    //       return {
    //         title,
    //         history: group,
    //       };
    //     });
    //   };

    const handleClearConversion = () => {
        // const transformedData = transformData(messages);
            // setMessageHistory(transformedData)         
        setMessages([]);
        setShowStartMessage(true)
        setConversationId(null);
        setSelectedMatch(null);
    }
    // const handleClearConversion = () => {
    //     if (messages.length > 0) {
    //         const groupedHistory = {
    //             title: messages[0]?.content || 'Untitled',
    //             history: messages,
    //         };
    //          setSavedQuestions((prevQuestions) => [...prevQuestions, groupedHistory]);
    //       }

    //     setMessages([]);
    //     setShowStartMessage(true);
    // };
     const historyUpdate = async (message, convId) => {
        
        try {
            console.log("Sending request to update conversation history...");
            const response = await axios.post(
                `${settings?.serverUrl}/history/update`,
                JSON.stringify({
                    conversation_id: convId,
                    messages: message,
                    user_id : user_id,
                    sourcedata:selectedCollection
                }),
                { headers }
              
            );

            console.log("histry update code received:", response);

            if (response?.status === 200) {
                if(messages?.length === 0){
                    handleSaveHistory()
                }
                //  const payload = response?.data;  
                // if (payload?.messages) {
                //      setMessages(payload?.messages);
                //     setShowStartMessage(false);
                // } else {
                //     console.warn("No messages found in response.");
                // }
            } else {
                console.error("Unexpected response status:", response.status);
            }
        } catch (error) {
            handleApiError(error, history);
            if (error.response) {
                console.error("API Error Response:", error.response.data);
            } else if (error.request) {
                console.error("No Response from API:", error.request);
            } else {
                console.error("Error:", error.message);
            }
        }
    };

   
    const handleHistoryRead = async (convId) => {
        // conversationId = convId;
        console.log("working as handleHistoryRead ")
         headers.Accept='application/json'
        try {
            setIsloader(true);
            const response = await axios.post(
                `${settings?.serverUrl}/history/read`,
                JSON.stringify({
                    conversation_id: convId,
                    user_id : user_id
                }),
                { headers }

            );

            console.log("Response received:", response);
            if(response?.status){
                const payload = JSON.parse(response?.data[0]?.body)
                setMessages(payload.messages);
                console.log("payload======",payload)
                setShowStartMessage(false)
            }
            // payload.messages.forEach(resultObj => {
            //     processResultMessage(resultObj, userMessage, convId)
            // })
        } catch (error) {
            handleApiError(error, history);
            if (error.response) {
                console.error("API Error:", error.response.data);
            } else if (error.request) {
                console.error("No Response:", error.request);
            } else {
                console.error("Error:", error.message);
            }
        } finally{
            setIsloader(false);
        }
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const today = new Date();
        
        // Reset time to midnight for accurate comparisons
        const resetTime = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
        const dateOnly = resetTime(date);
        const todayOnly = resetTime(today);
        
        const timeDifference = todayOnly - dateOnly;
        const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
      
        if (daysDifference === 0) {
          return "Today";
        } else if (daysDifference === 1) {
          return "Yesterday";
        } else if (daysDifference > 1 && daysDifference <= 7) {
          return "Previous 7 Days";
        } else if (daysDifference > 7 && daysDifference <= 30) {
          return "Previous 30 Days";
        }
      
        // Year-wise grouping for dates older than 30 days
        return date.getFullYear().toString();
      };
      
      const groupByDate = (questions) => {
        const grouped = questions.reduce((acc, curr) => {
          const group = formatDate(curr.createdAt); // Determine the group for each item
          if (!acc[group]) acc[group] = [];
          acc[group].push(curr);
          return acc;
        }, {});
        return grouped;
      };


    const handleSaveHistory = async (showFirstChatData, isLoading) => {
        try {
            if(!isLoading){
                setIsHistoryLoading(true)
            }
            const response = await axios.get(
                `${settings?.serverUrl}/history/list?offset=0&user_id=${user_id}`,
                { headers }
            );

            console.log("Response received:", response.data);
            const payload = JSON.parse(response.data[0].body)
            console.log("payload received:", payload);

            if (!Array.isArray(payload)) {
                console.error('There was an issue fetching your data?.')
                return null
            }
            const groupedChats = groupByDate(payload);
            console.log("groupedChats----=",groupedChats)
            setSavedQuestions(groupedChats)
             if(payload?.length > 0 && showFirstChatData){
                handleHistoryRead(payload[0]?.id)
                // conversationId = 
                setConversationId(payload[0]?.id)
             }
            //  payload.map(async () => {

                //  let convMessages: ChatMessage[] = []
                //  convMessages = await historyRead(conv.id)
                //    .then(res => {``
                //      return res
                //    })
                //    .catch(err => {
                //      console.error('error fetching messages: ', err)
                //      return []
                //    })
                //  const conversation: Conversation = {
                //    id: conv.id,
                //    title: conv.title,
                //    date: conv.createdAt,
                //    messages: convMessages
                //  }
                //  return conversation
            // })
            //  )

        } catch (error) {
            handleApiError(error, history);
            if (error.response) {
                console.error("API Error:", error.response.data);
            } else if (error.request) {
                console.error("No Response:", error.request);
            } else {
                console.error("Error:", error.message);
            }
        }finally{
            setIsHistoryLoading(false)
        }
    };

    const fetchSuggestionsList = async () => {
        try {
            setIsSuggessionLoading(true)
            const response = await axios.get(
                `${settings?.serverUrl}/suggestions`,
                { headers }
            );
            console.log("setSuggestionlist",response?.data?.result)
            if(response?.data?.result?.length > 0){
                setSuggestionlist(response?.data?.result)
            }
        } catch (error) {
            handleApiError(error, history);
            if (error.response) {
                console.error("API Error:", error.response.data);
            } else if (error.request) {
                console.error("No Response:", error.request);
            } else {
                console.error("Error:", error.message);
            }
        }finally{
            setIsSuggessionLoading(false)
        }
    };

    const handleDownload = async (fileName, original_filename) => {
        try {
            setIsFileDownloadLoading(true);
            
            let filePath = 'fileprocessing/UL_Wells/'
            if(fileName?.includes('page')){
                filePath = filePath + 'pages/'
            }
          const param = { fileName: fileName, filePath: filePath };
          console.log("param-----",param)
          const apiResponse = await axios.post(
            `${settings.serverUrl}/getSearchPdfFile`,
            param,  
            { headers }
          );
          console.log("api resonse====",apiResponse,abortController.signal.aborted)
          if(!abortController.signal.aborted){
          if(apiResponse?.status === 200){
                const results = apiResponse?.data?.result?.base64Str;
                setPdfUrl(results);
                setIsDrawerOpen(true);
                // const link = document.createElement('a');
                // link.href = `data:application/pdf;base64,${results}`;
                // link.download = `${original_filename}`; 
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);
                // toast.success(`${original_filename} downloaded successfully`);
          }else{
            toast.error("Pdf download failed");
          }
        }
        } catch (error) {
            handleApiError(error, history);
            toast.error("Pdf download failed");
          console.error('Error fetching PDF:', error);
        } finally {
            setIsFileDownloadLoading(false);
        }
      };  

      const handleEdit = (id, currentValue) => {
        setEditingItemId(id);
        setEditValue(currentValue);
        setAnchorEl(null);
      };

      const updateHistoryListItem =async (id, editValue) => {
        try {
            setIsEditHisotryLoading(true);
          const param = { title: editValue, conversation_id: id, user_id : user_id };
          console.log("param-----",param)
          const apiResponse = await axios.post(
            `${settings.serverUrl}/history/rename`,
            param,  
            { headers }
          );
          console.log("api resonse====",apiResponse)
          if(apiResponse?.status === 200){
                 handleSaveHistory(null, true);
                 toast.success(`History rename successfully`);
                 setEditingItemId(null);
                 handleMenuClose();
          }else{
            toast.error("Field to rename the history list");
          }
        } catch (error) {
            handleApiError(error, history);
            toast.error("Field to rename the history list");
          console.error('Error fetching PDF:', error);
        } finally {
            setIsEditHisotryLoading(false);
        }
      }

      const handleFeedback =async (payload, msg_index, msg_type) => {
        try {
            setIsLikeDislikeLoading(true);
          
            console.log("handleFeedback pay;paddd",payload)
          const apiResponse = await axios.post(
            `${settings.serverUrl}/likeDislikeConversation`,
            { conversation : payload } ,
            { headers }
          );
          console.log("api resonse====",apiResponse)
          if(apiResponse?.status === 200){
            if(msg_type === 'like'){
                messages[msg_index].like = true
                messages[msg_index].dislike = false
            }else if(msg_type === 'dislike'){
                messages[msg_index].like = false
                messages[msg_index].dislike = true
            }
            console.log("msg------",messages)
            setMessages(messages)
          }else{
            toast.error("Field to send feedback");
          }
        } catch (error) {
            toast.error("Field to send feedback");
            handleApiError(error, history);
          console.error('Error fetching PDF:', error);
        } finally {
            setIsLikeDislikeLoading(false);
        }
      }
    
      const handleSave = (id) => {
        updateHistoryListItem(id, editValue);
      };
    
      const handleCancel = () => {
        setEditingItemId(null);
        handleMenuClose();
      };
    
      const handleMenuOpen = (event, id) => {
        setAnchorEl(event.currentTarget);
        setDropdownItemId(id);
      };
    
      const handleMenuClose = () => {
        setAnchorEl(null);
        setDropdownItemId(null);
      };

      const handleSelectCitation = (match) => {
        setIsFileDownloadLoading(false);
        setSelectedMatch(match);
      }

      useEffect(() =>{
        return () => {
            abortController.abort();
        }
      },[selectedMatch])
    
    return (
        <>
        <form onSubmit={submitEditHandler}>
            {/* <CCard>
                <CRow style={title_text} onClick={() => history.goBack()}>
                    <Stack flexDirection={'row'} spacing={2}>
                        <i class="fa fa-chevron-circle-left" aria-hidden="true" style={{ fontSize: '25px', marginRight: '5px' }}></i>
                    </Stack>
                </CRow>
            </CCard> */}


            
                <TheHeader />

            

            {/* <div className='right_bar'>
                <span><i class="fa fa-home" aria-hidden="true"></i></span>
                <span><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </span>
                <span><i class="fa fa-file-text-o" aria-hidden="true"></i>
                </span>
                <span><i class="fa fa-cloud-upload" aria-hidden="true"></i>
                </span>
                <span><i class="fa fa-th-large" aria-hidden="true"></i>
                </span>
                <span><i class="fa fa-cogs" aria-hidden="true"></i>
                </span>
            </div> */}

                
                <Box className='main_container'> 
                    {/* <Box>
                    <Stack direction="row" spacing={2} style={{ alignItems: 'center' }}>
                        <i
                            className="fa fa-chevron-circle-left"
                            aria-hidden="true"
                            style={{
                                fontSize: '25px',
                                marginRight: '5px',
                                marginLeft:'50px',
                                cursor: 'pointer',
                                color: '#4ea7d8',
                            }}
                            onClick={() => history.goBack()}
                        />
                    </Stack>
                    </Box> */}

                    <Box className='button_bar'>
                        <CButton
                            size="sm"
                            onClick={handleClearConversion}
                        >
                            New Chat
                        </CButton>
                        <CButton
                            size="sm"
                            onClick={() => {
                                setShowChatHistory(!showChatHistory)
                                setShowSuggesion(false)
                            }
                            }
                            
                        >
                            {showChatHistory ? 'Hide History' : 'Chat History'}
                        </CButton>
                        <CButton
                            size="sm"
                            onClick={() => {
                                setShowSuggesion(!showSuggesion)
                                setShowChatHistory(false)
                            }
                            }
                            
                        >
                            {showSuggesion ? 'Hide Suggestion' : 'Suggestions'}
                        </CButton>
                    </Box>
                
                

                <Box className="ai-search-page">
                <Box
  className={`content-container ${
    selectedMatch && (showChatHistory || showSuggesion)
      ? "side_container_open_citation"
      : selectedMatch || showChatHistory || showSuggesion
      ? "side_container_open"
      : "side_container_close"
  }`}

>

                            <Box className="chat-container">
                                    {showStartMessage && (
                                            <CRow className="Start_Message_Heading">
                                                <h2>What can I help with?</h2>
                                                <p>This chatbot is configured to answer your questions</p>
                                            </CRow>
                                    )}
                                    <Box style={{overflowY: 'auto', minHeight : "40px", width: "100%"}}>
                                        {console.log("messages--",messages)}
                                    <CContainer>
                                    <CRow className="messages">
                                            {messages?.map((msg, index) => (
                                                <>
                                                <span key={index} className="message-item">
                                                    {msg.role === 'user' ? (
                                                        <Badge className='msgquery' color="secondary" badgeContent={msg?.sourcedata?msg.sourcedata:"None"}>
                                                        <p>{msg.content}</p>
                                                    </Badge>
                                                    ) : msg.role === 'assistant' ? (
                                                        <span className='msgreply'>
                                                            {msg?.content?.bot_message}
                                                            {msg?.content?.matches?.length > 0 &&
                                                                <Accordion style={{boxShadow: 'none', display:"table"}}>
                                                                <AccordionSummary
                                                                  expandIcon={<ExpandMoreIcon />}
                                                                  aria-controls="panel1a-content"
                                                                  id="panel1a-header"
                                                                >
                                                                  <Typography variant="body1" style={{fontSize:"0.9em"}}>{msg?.content?.matches?.length} References</Typography>
                                                                </AccordionSummary>
                                                                <AccordionDetails>
                                                                  {msg?.content?.matches?.map((match, index) => (
                                                                     <Chip 
                                                                     label={`Citation ${index + 1}`} 
                                                                     color="primary"
                                                                     variant='outlined'
                                                                     style={{cursor: 'pointer', margin:"2px 5px 0px 0px"}}
                                                                     key={match.id}
                                                                     onClick={() => {
                                                                        handleSelectCitation(match)
                                                                        console.log("matches-----",match)
                                                                      
                                                                     }} />
                                                                  ))}
                                                                </AccordionDetails>
                                                              </Accordion>
                                                                }
                                                        </span>
                                                                ) : null}
                                                        </span>
                                                        {
                                                            msg.role === 'assistant' && 
                                                            <Box style={{ display: 'flex' }}>
                                                                {
                                                                     <Tooltip title="Like" arrow>
                                                                        <IconButton
                                                                            disabled={msg?.like}
                                                                            onClick={() =>{
                                                                                const likePayload = {
                                                                                    ...msg,
                                                                                    prompt_id: msg?.id,
                                                                                    like: true,
                                                                                    dislike: false,
                                                                                    userId : user_id
                                                                                }
                                                                                handleFeedback(likePayload, index, 'like');
                                                                                setSelectedMessage(index)
                                                                            }}
                                                                        >
                                                                            <ThumbUpOffAltIcon fontSize='small' style={{ color : msg?.like && 'blue' }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                }

                                                                {
                                                                    <Tooltip title="Dislike" arrow>
                                                                        <IconButton
                                                                            disabled={msg?.dislike}
                                                                            onClick={() => {
                                                                                const likePayload = {
                                                                                    ...msg,
                                                                                    prompt_id: msg?.id,
                                                                                    like: false,
                                                                                    dislike: true,
                                                                                    userId : user_id
                                                                                }
                                                                                handleFeedback(likePayload, index, 'dislike');
                                                                                setSelectedMessage(index)
                                                                            }}
                                                                        >
                                                                            <ThumbDownOffAltIcon fontSize='small'  style={{ color : msg?.dislike && 'red' }}/>
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                }
                                                                {isLikeDislikeLoading && index === selectedMessage && <CircularProgress size={18} style={{ marginTop : 10 }} />}
                                                            </Box>
                                                        }
                                                       
                                            </>
                                                    ))}

                                             <span ref={messagesEndRef}></span>
                                    </CRow>
                                    </CContainer>
                                    </Box>
                                
                                {Isloader &&
                                  <Box style={loader}>
                                                <CircularProgress style={{ margin: "28% auto", display: "block" }} />
                                    </Box>}
                                    <div
                                    className="text-light text-dark d-flex flex-column justify-content-center"
                                    style={{ width: "60%" }}
                                >
                                    <div>
                                        <label htmlFor="collectionName">
                                            <strong>Select Data Source:</strong>
                                        </label>
                                        <select
                                            id="collectionName"
                                            name="collectionName"
                                            value={selectedCollection}
                                            onChange={(e) => setSelectCollection(e.target.value)}
                                        >
                                            <option value="none">-None-</option>
                                            <option value="headerdata">Header Data</option>
                                            <option value="lease">Lease Data</option>
                                            <option value="timelog">Timelog</option>
                                        </select>
                                    </div>

                                    <Box className="input-container">
                                        <CInput
                                            type="text"
                                            value={input}
                                            onChange={(e) => setInput(e.target.value)}
                                            placeholder="Type your message here..."
                                        />
                                        <SendRoundedIcon
                                            onClick={submitEditHandler}
                                            style={{ cursor: "pointer" }}
                                        />
                                    </Box>
                                </div>
                                  
                            </Box>

                            {
                                selectedMatch && 
                                <Box className="side-table">
                                    <CCol className="chat-history">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <div className='side_title'>
                                        <p ><strong>Citations</strong></p>
                                        <span
                                        onClick={() => setSelectedMatch(null)}
                                        >
                                        <i class="fa fa-times" style={{ cursor : 'pointer' }} aria-hidden="true"></i>
                                        </span>
                                        </div>
                                    </div>
                                    {/* <pre>{JSON.stringify(selectedMatch, null, 2)}</pre> */}
                                    {/* <CRow className="justify-content-center mt-4"> */}
                                        <CCol md={12} style={{fontSize:13}}>
                                            <CRow className="mb-2">
                                            <CCol xs={12} className="mb-1">
                                                <strong>API Number:</strong>
                                            </CCol>
                                            <CCol xs={12} className='citation-text'>{selectedMatch?.APINbr || '-'}</CCol>
                                            </CRow>
                                            <CRow className="mb-2">
                                            <CCol xs={12} className="mb-1">
                                                <strong>Company Name:</strong>
                                            </CCol>
                                            <CCol xs={12} className='citation-text'>{selectedMatch?.CompanyName || '-'}</CCol>
                                            </CRow>
                                            <CRow className="mb-2">
                                            <CCol xs={12} className="mb-1">
                                                <strong>Field Name:</strong>
                                            </CCol>
                                            <CCol xs={12} className='citation-text'>{selectedMatch?.FieldName || '-'}</CCol>
                                            </CRow>
                                            <CRow className="mb-2">
                                            <CCol xs={12} className="mb-1">
                                                <strong>Well Name:</strong>
                                            </CCol>
                                            <CCol xs={12} className='citation-text'>{selectedMatch?.WellName || "-"}</CCol>
                                            </CRow>
                                            <CRow className="mb-2">
                                            <CCol xs={12} className="mb-1">
                                                <strong>File Name:</strong>
                                            </CCol>
                                            <CCol xs={12}>
                                                {
                                                  selectedMatch?.original_filename && selectedMatch?.file_incoming_name ?
                                                  <CRow
                                                  style={{cursor:'pointer'}} className="file-download"
                                                  onClick={() => {
                                                     handleDownload(selectedMatch?.file_incoming_name, selectedMatch?.original_filename)}
                                                    }>
                                                     {/* <CCol sm={1}></CCol> */}
                                                     <CCol sm={11}><span><DownloadIcon className="me-2" style={{fontSize: '20px'}}/></span>{selectedMatch?.original_filename} <span style={{ marginLeft : 5 }}>{isFileDownloadLoading && <CircularProgress size={20} />}</span></CCol>
                                                     {/* <CCol sm={1}></CCol>   */}
                                                 </CRow>
                                                 : "-"
                                                }
                                            </CCol>
                                            </CRow>
                                            <CRow className="mb-2">
                                            <CCol xs={12} className="mb-1">
                                                <strong>Pdf Content:</strong>
                                            </CCol>
                                            <CCol xs={12} className='citation-text'>{selectedMatch?.pdf_content || '-'}</CCol>
                                            </CRow>
                                            {/* <CRow>
                                            <CCol xs={12} className="mb-2">
                                                <strong>File:</strong>
                                            </CCol>
                                            <CCol xs={12}>

                                            {
                                                selectedMatch?.file_incoming_name ?
                                                <CButton
                                                color="info"
                                                size="sm"
                                                style={{ color: 'white'}}
                                                onClick={() => handleDownload(selectedMatch?.file_incoming_name, selectedMatch?.original_filename)}
                                                className="d-flex align-items-center"
                                                >
                                                {
                                                    isFileDownloadLoading ? <CircularProgress size={20} /> :
                                                   <span><DownloadingIcon className="me-2"  style={{cursor:'pointer'}} />  Download File</span> 
                                                }
                                                 </CButton>
                                                : '-'
                                            }
                                            </CCol>
                                            </CRow> */}
                                        </CCol>
                                        {/* </CRow> */}

                                    </CCol>
                                    </Box>
                            }

                        {showChatHistory && (
                            <CCol className="side-table">
                                <CCol className="chat-history">
                                <CRow className="clear-conversion">
                                    <CCol>
                                        <div className='side_title'>
                                        <p>
                                            <strong>Chat History</strong>
                                        </p>
                                        {
                                            Object.keys(savedQuestions)?.length > 0 && 
                                            <IconButton
                                            onClick={(e) => {
                                            setIsDeleteAllMenuOpen(!isDeleteAllMenuOpen);
                                            setAnchorE2(e.currentTarget); // Correctly set the clicked element as anchor
                                            }}
                                            >
                                                <MoreHorizIcon />
                                            </IconButton>
                                        }
                                        
                                        <Menu
                                            anchorEl={anchorE2}
                                            open={isDeleteAllMenuOpen}
                                            onClose={() => {
                                                setAnchorE2(null)
                                                setIsDeleteAllMenuOpen(false)}}
                                        >
                                            <MenuItem  onClick={() => {
                                                setIsDeleteAllConfirmationOpen(true);
                                                setIsDeleteAllMenuOpen(false)
                                                setAnchorE2(null);
                                            }}>
                                            <DeleteIcon fontSize="small" style={{ marginRight: "5px" }} />
                                                 Clear all chat history
                                            </MenuItem>
                                        </Menu>
                                        <span style={{ cursor : 'pointer' }} onClick={() => setShowChatHistory(false)}><i class="fa fa-times" aria-hidden="true"></i></span>
                                    </div>
                                       
                                {isHistoryLoading ?
                                    <Box >
                                        <CircularProgress />
                                    </Box>
                                    :
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                        {Object.keys(savedQuestions).map((date, index) => (
                                            <li key={index}>
                                            <p style={{ fontWeight: "bold", margin: "10px 0px" }}>{date}</p>
                                           {savedQuestions[date].map((data) => (
                                            <li
                                            key={data?.id}
                                            // onClick={() => handleHistoryRead(data?.id)}
                                            className='history-list'
                                            onMouseEnter={(e) => {
                                                setHoveredItemId(data?.id);
                                                e.currentTarget.style.backgroundColor = '#e0e0e0'}}
                                            onMouseLeave={(e) => {
                                                setHoveredItemId(null)
                                                e.currentTarget.style.backgroundColor = 'transparent'
                                            }}
                                            >
                                            {/* <span>{data?.title}</span>
                                            {hoveredItemId === data?.id && (
                                            <span
                                                color="error"
                                                onClick={(e) => {
                                                e.stopPropagation(); 
                                                setIsDeleteConfirmationOpen(true);
                                                setSelectedChatConvId(data?.id)
                                                }}
                                            >
                                                <i class="fa fa-times" aria-hidden="true"></i>

                                            </span>
                                            )} */}
                                            {editingItemId === data?.id ? (
                                                <>
                                                    <CCol md={10} sm={12}>
                                                    <CInput
                                                            type="text"
                                                            value={editValue}
                                                            onChange={(e) => setEditValue(e.target.value)}
                                                            style={{ marginRight: "5px", padding: "5px", width :" 100%" }}
                                                        />
                                                    </CCol>
                                                    <CCol md={1} sm={6}>
                                                    {
                                                    isEditHisotryLoading ? <CircularProgress size={15} style={{ marginRight : '5px' }}/> :
                                                        <IconButton onClick={() => handleSave(data?.id)}>
                                                            <CheckIcon color="success" />
                                                        </IconButton>
                                                    }
                                                    </CCol>
                                                    <CCol md={1} sm={6}>
                                                        <IconButton onClick={handleCancel}>
                                                            <CloseIcon color="error" />
                                                        </IconButton>
                                                    </CCol>
                                                </>
                                                
                                            ) : (
                                                <CCol style={{ display : "flex", justifyContent : "space-between"}}>
                                                    {/* <CCol md={11}> */}
                                                        <span onClick={() => handleHistoryRead(data?.id)}>
                                                            {data?.title}
                                                        </span> 
                                                    {/* </CCol>
                                                    <CCol md={1}> */}
                                                        {hoveredItemId === data?.id && (
                                                            // <span
                                                            // onClick={(e) => handleMenuOpen(e, data?.id)}
                                                            // >
                                                            // <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                                            // </span>
                                                            <IconButton
                                                                style={{ fontSize : '13px', marginTop : '-10px'}}
                                                                onClick={(e) => {
                                                                    handleMenuOpen(e, data?.id)
                                                                }}
                                                            >
                                                                <MoreVertIcon />
                                                            </IconButton>
                                                        )}
                                                    {/* </CCol> */}
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    open={dropdownItemId === data?.id}
                                                    onClose={handleMenuClose}
                                                >
                                                    <MenuItem
                                                    onClick={() =>
                                                        handleEdit(data?.id, data?.title)
                                                    }
                                                    >
                                                    <EditIcon fontSize="small" style={{ marginRight: "5px" }} />
                                                    Edit
                                                    </MenuItem>
                                                    <MenuItem
                                                    onClick={() => {
                                                        setIsDeleteConfirmationOpen(true);
                                                        setSelectedChatConvId(data?.id);
                                                        handleMenuClose();
                                                    }}
                                                    >
                                                    <DeleteIcon fontSize="small" style={{ marginRight: "5px" }} />
                                                    Delete
                                                    </MenuItem>
                                                </Menu>
                                                </CCol>
                                            )}
                                            </li>
                                        ))}
                                            </li>
                                        ))}
                                    </ul>}
                                    </CCol>
                                    </CRow>
                            </CCol>
                            {/* <p>
                                <strong>Suggestions</strong>
                            </p>
                            {isSuggessionLoading ?
                                <Box >
                                    <CircularProgress />
                                </Box>
                            : suggestionlist?.map((val) => (
                                <ul>
                                        <li
                                            onClick={() => setInput(val?.message)}
                                            style={{ cursor: 'pointer' }}
                                            key={val?.message}
                                        >
                                            {val?.message}
                                        </li>
                                </ul>
                            ))} */}
                            </CCol>
                        )}
                         {
                                showSuggesion && 
                                <Box className="side-table">
                                    <CCol className="chat-history">
                                        <div className='side_title'>
                                    <p>
                                        <strong>Suggestions</strong>
                                    </p>
                                    <span style={{ cursor : 'pointer' }} onClick={() => setShowSuggesion(false)}><i class="fa fa-times" aria-hidden="true" ></i></span>
                                    </div>
                                    {isSuggessionLoading ?
                                    <Box>
                                        <CircularProgress />
                                     </Box>
                                    : suggestionlist?.map((val) => (
                                        <ul>
                                                <li
                                                    onClick={() => setInput(val?.message)}
                                                    style={{ cursor: 'pointer' }}
                                                    key={val?.message}
                                                >
                                                    {val?.message}
                                                </li>
                                        </ul>
                                    ))}
                                    </CCol>
                                </Box>
                            }
                        

                       
                         </Box>
                </Box>
                </Box>
        </form>
        <ChatDeleteConfirmation 
            isDeleteConfirmationOpen={isDeleteConfirmationOpen} 
            setIsDeleteConfirmationOpen={setIsDeleteConfirmationOpen} 
            selectedChatConvId={selectedChatConvId} 
            handleSaveHistory={handleSaveHistory}
            conversationId={conversationId}
            handleClearConversion={handleClearConversion}
        />
        <ChatDeleteAllConfirmation
             isDeleteAllConfirmationOpen={isDeleteAllConfirmationOpen} 
             setIsDeleteAllConfirmationOpen={setIsDeleteAllConfirmationOpen}
             handleSaveHistory={handleSaveHistory}
             handleClearConversion={handleClearConversion}
        />
        <AiSearchPdfDrawer isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} isFileDownloadLoading={isFileDownloadLoading} pdfUrl={pdfUrl}/>
        <ToastContainer style={{width:'450px'}} />
         </>
    );
};

export default AiSearchPage;